import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { InjectionToken } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { APP_COMPONENTS_REGISTRY } from '@app/app-components.registry';
import { LAB_COMPONENTS_REGISTRY } from '@lab/lab-components.registry';
import { mpsRegisterComponents } from '@mps/mps-kit/mps-component-loader';
import { MPS_COMPONENTS_REGISTRY } from '@mps/mps-kit/mps-components.registry';
import { environment } from './environments/environment';
import { globalConfig } from './global.config';
import { MpsAppComponent } from './mps/components/mps-app/mps-app.component';

registerLocaleData(localeFr);
registerLocaleData(localeEn);


export const OAUTH2_PROVIDERS_URL = new InjectionToken<string>('OAUTH2_PROVIDERS_URL');
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
export const LOADER_ON_HTTP = new InjectionToken<string>('LOADER_ON_HTTP');

/**
 * @MPS-KIT:TODO add your lazy-loaded components here
 * - Registers lazy-loaded Apps components for dynamic component loading (improves initial bundle size)
 */
mpsRegisterComponents({
  ...APP_COMPONENTS_REGISTRY,
  ...MPS_COMPONENTS_REGISTRY,
  ...(environment.mpsKit.enableLab ? LAB_COMPONENTS_REGISTRY : {}),
});

bootstrapApplication(MpsAppComponent, globalConfig).catch((err) => console.error(err));
